import React, { useEffect } from "react";
import bg from "../assets/picto.svg";
import check from "../assets/check.png";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { useTunnelData } from "../TunnelContext";
import pushEvent from '../pushEvent'

function digestMessage(message) {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  return window.crypto.subtle.digest("SHA-256", msgUint8) // hash the message
    .then(hashBuffer => {
      const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join(""); // convert bytes to hex string
      return hashHex;
    })
}

export default function Done() {

  const { t } = useTranslation();
  const { tunnel } = useTunnelData();

  useEffect(() => {
    if (!tunnel.sales) {
      return;
    }

    if( tunnel.club?.fbq && window.fbq) {
      window.fbq('track', 'PageView');
    }

    try {
      Promise.all([
        digestMessage(tunnel.user.email.trim().toLowerCase()),
        digestMessage(tunnel.user.phone.replace(/[^0-9]/g, '')),
        digestMessage(tunnel.user.firstName.trim().toLowerCase()),
        digestMessage(tunnel.user.lastName.trim().toLowerCase()),
        digestMessage(tunnel.user.zipcode.replace(/[^0-9]/g, '')),
        digestMessage(tunnel.user.city.trim().toLowerCase()),
      ])
        .then(([em, ph, fn, ln, zp, ct]) => {
          pushEvent({
            'event': 'funnel_step_final',
            'step_name': 'Abonnement',
            'funnel_club': tunnel.club.name,
            'funnel_club_status': 'Ouvert',
            'funnel_abo': tunnel.offer.offer.name,
            em, ph, fn, ln, zp, ct
          });
        })
    } catch (e) {
      console.error(e);
    }

    pushEvent({
      event: 'purchase',
      // 'transaction_id: '1723804',
      currency: 'EUR',
      value: tunnel.sales.totalTI,
      tax: tunnel.sales.totalTI - tunnel.sales.totalTE,
      'items': [{
        item_id: tunnel.offer['@id'],
        item_name: tunnel.offer.name,
        price: tunnel.offer.offer.registrationFeeTE,
        price_tax_exc: tunnel.offer.offer.registrationFeeTE,
        price_tax_inc: tunnel.offer.offer.registrationFeeTI
      }]
    });

  }, []);

  return (
    <>
      <div className="relative h-screen flex flex-col justify-center items-center overflow-hidden">
        <div className="relative w-full flex flex-col justify-center items-center flex-1 ">
          <div className="w-full   z-10  flex items-center flex-col gap-5 xl:gap-10 ">
            <h2 className="text-2xl text-center sm:text-6xl lg:text-[70px] font-bold whitespace-nowrap sm:whitespace-normal">
              {t("confirmation.title.p1").toUpperCase()}{" "}
              <span className="block sm:inline">{t("confirmation.title.p2").toUpperCase()}</span>
            </h2>
            <div className="hidden md:flex flex-col justify-center items-center text-oaPlaceholderText md:text-2xl text-4xl font-normal ">
              <div>{t("confirmation.sub_title.p1")}</div>
              <div>{t("confirmation.sub_title.p2")}</div>
              <div>{t("confirmation.sub_title.p3")}</div>
            </div>
            <img src={check} className="w-[76px] md:w-[120px] xl:w-[185px]" alt="check" />
            <Link
              to="/"
              className="px-5 py-3 lg:py-4 bg-oaRed text-white text-xs lg:text-xl font-bold rounded-[5px]"
            >
              {t("confirmation.go_home").toUpperCase()}
            </Link>
          </div>
          <img
            src={bg}
            alt="page background"
            className="absolute w-[700px] bottom-0 -right-16 xl:left-1 xl:bottom-1 xl:size-[700px] z-0"
          />
        </div>
        {!!tunnel && <img src={`https://sekoya.go2cloud.org/aff_goal?a=l&goal_name=cpa&adv_id=527&offer_id=173&adv_sub=${tunnel.trackerUid}&conversion_unique_id=173-${tunnel.trackerUid}&amount=${tunnel?.sales?.totalTI || 0}`} width="1" height="1" />}
      </div>
      <footer className="w-full md:hidden">
        <Footer></Footer>
      </footer>
    </>
  );
}
